import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Materials_ds_get_substitutions_by_material_id_packaging_idService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { material_id: number, packaging_id: number }): 
  Promise<{ result: { Id?: number, MaterialId?: number, PackagingId?: number, Priority?: number, Ratio?: number, SubstitutionMaterialId?: number, SubstitutionPackagingId?: number, SubstitutionMaterialPackagingLookup?: { MaterialId?: number, Material?: { LookupCode?: string } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.material_id)) {
      missingRequiredInParams.push('\'material_id\'');
    }
    if (isNil(inParams.packaging_id)) {
      missingRequiredInParams.push('\'packaging_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Materials/datasources/ds_get_substitutions_by_material_id_packaging_id/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { material_id: number, packaging_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, MaterialId?: number, PackagingId?: number, Priority?: number, Ratio?: number, SubstitutionMaterialId?: number, SubstitutionPackagingId?: number, SubstitutionMaterialPackagingLookup?: { MaterialId?: number, Material?: { LookupCode?: string } } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.material_id)) {
      missingRequiredInParams.push('\'material_id\'');
    }
    if (isNil(inParams.packaging_id)) {
      missingRequiredInParams.push('\'packaging_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Materials/datasources/ds_get_substitutions_by_material_id_packaging_id/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { material_id: number, packaging_id: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, MaterialId?: number, PackagingId?: number, Priority?: number, Ratio?: number, SubstitutionMaterialId?: number, SubstitutionPackagingId?: number, SubstitutionMaterialPackagingLookup?: { MaterialId?: number, Material?: { LookupCode?: string } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.material_id)) {
      missingRequiredInParams.push('\'material_id\'');
    }
    if (isNil(inParams.packaging_id)) {
      missingRequiredInParams.push('\'packaging_id\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Materials/datasources/ds_get_substitutions_by_material_id_packaging_id/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      material_id: number, packaging_id: number    }) {
        if(isNil(inParams.material_id)) {
          return true; 
        }
        if(isNil(inParams.packaging_id)) {
          return true; 
        }
      return false;
    }
}
